export default "__VITE_ASSET__DXXZ$QPX__"